import { Collection, Model } from 'mobx-rest'
import { observable, computed, action } from "mobx"
import { apiClient } from 'mobx-rest'
import moment from 'moment'


class SensorModel extends Model {

  @observable chartData = {}
  @observable chartDataLoaded = false

  primaryKey() {
    return 'slug'
  }

  @computed get latlong() {
        var latlong = this.get('location').split(',')
        if(latlong.length === 2) {
          latlong[0] = parseFloat(latlong[0])
          latlong[1] = parseFloat(latlong[1])
        } else {
          latlong = [0, 0]
        }

        return latlong
    }


    @action async fetchChartData () {
      const slug = this.get('slug')
      let body

      const { promise } = apiClient().get(
        '/sensors/' + slug + '/chart-data',
        body || {}
      )

      try {
        this.chartData = await promise

        this.chartDataLoaded = true
      } catch(body) {
        throw body
      }

    }

    @computed get alarms()
    {
      if (typeof this.chartData.alarms !== 'undefined') {
        return this.chartData.alarms
      }
      
      return []
    }

    @computed get filteredChartData()
    {
      // Filter error values
      let filteredData = this.chartData.data.filter(function(value, index, arr){return value.depth < 8190;});

      // Convert dateTime to epoch
      filteredData.forEach((element, index) => {
          filteredData[index].unixtime = moment(element.dateTime).unix()
      });
      
      return filteredData.slice().reverse()
    }

    @computed get chartDataDomain()
    {
      var max = this.get('height')
      var min = 0

      return [min, max]
    }

    /* Get the X domain, adding some space to right hand side
    */
    @computed get chartXDomain()
    {
      var min = 0
      var max = 0

      if(this.chartData.end)
      {
          max = moment(this.chartData.end).add(2, 'hours').unix()
          min = moment(this.chartData.start).unix()
      }

      return [min, max]
    }

    @computed get chartYTicks()
    {
      var max = moment(this.chartData.end).unix()
      return [max, max-43200, max-86400, max-129600, max-172800]
    }

    @computed get chartYTickLabels()
    {
      var labels = []
      var max = moment(this.chartData.end).unix()


      labels[max] = "Now"
      labels[max-43200] = "12hrs"
      labels[max-86400] = "24hrs"
      labels[max-129600] = "36hrs"
      labels[max-172800] = "48hrs"

      return labels
    }
}

class SensorsCollection extends Collection {
  url ()  { return `/sensors` }
  model () { return SensorModel }
}

export default new SensorsCollection()



// WEBPACK FOOTER //
// ./src/stores/sensors.js